export default __webpack_public_path__ + "src/docs/packages/eco-karoo-lodge.pdf";